export default {
  pages: {
    applicationsShow: {
      pageTabs: ['Ariza haqida', "To'lov grafik va tafsilotlari"],
      applicationItemsTable: {
        title: 'Qaytarilgan tovarlar',
      },
      statusChangedToast: "Ariza holati o'zgardi",
    },
  },
};
